import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../flux';
import { images, texts, videos, quem_somos } from '../../settings';
import { PersonProfile, VideoBg, DelayLink, HoveredImage } from '../../components';

import './QuemSomos.scss';

class QuemSomos extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,

      maxSlidesQuemSomos: 3,
      cActiveQuemSomos: 0,
      loaderBarWidthQuemSomos: 0,
      loaderBarIndexQuemSomos: 0,
      //
      tempoSlider: 15000,
    };

    this.images = images;
    this.videos = videos;
    this.texts = texts;
    this.quem_somos_texts = quem_somos;

    this.contentText = React.createRef();
    this.runTransition = this.runTransition.bind(this);
  }

  scrollTop() {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  runTransition() {
    Actions.globalTransition();
  }

  changeTemasButton(num, tipoTema) {
    const newIndex = Object.assign({}, this.state);
    if (num == newIndex[`cActive${tipoTema}`]) {
      return false;
    }
    newIndex[`cActive${tipoTema}`] = num;
    this.setState(newIndex);
    this.reloadTimer(tipoTema);
  }

  changeTemasPrev(num, tipoTema) {
    const newIndex = Object.assign({}, this.state);
    newIndex[`cActive${tipoTema}`] = newIndex[`cActive${tipoTema}`] - 1 < 0 ? newIndex[`maxSlides${tipoTema}`] : num;
    this.setState(newIndex);
    this.reloadTimer(tipoTema);
  }

  changeTemasNext(num, tipoTema) {
    const newIndex = Object.assign({}, this.state);
    newIndex[`cActive${tipoTema}`] = newIndex[`cActive${tipoTema}`] + 1 > newIndex[`maxSlides${tipoTema}`] ? 0 : num;
    this.setState(newIndex);
    this.reloadTimer(tipoTema);
  }

  loadBar(tipoTema) {
    var percent = this.state.tempoSlider / 100;
    setInterval(() => {
      let index = this.state[`loaderBarIndex${tipoTema}`];
      index++;
      if (index <= 100) {
        const newIndex = Object.assign({}, this.state);
        newIndex[`loaderBarIndex${tipoTema}`] = index;
        newIndex[`loaderBarWidth${tipoTema}`] = index + '%';
        this.setState(newIndex);
      } else {
        this.changeTemasNext(this.state[`cActive${tipoTema}`] + 1, tipoTema);
      }
    }, percent);
  }

  reloadTimer(tipoTema) {
    this.setState({ loaderBarIndexQuemSomos: 0, loaderBarWidthQuemSomos: 0 });
  }

  componentDidMount() {
    Actions.headerIntern();
    this.scrollTop();

    // this.loadBar('QuemSomos');
  }

  render() {
    const { cActiveQuemSomos, loaderBarWidthQuemSomos, maxSlidesQuemSomos } = this.state;

    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Quem Somos - {this.texts.title}</title>
        </Helmet>

        <div className="parallax-image">
          {/* <img src={this.images.quem_somos.first_bg} /> */}
        </div>

        <div className="quem-somos" ref="quem-somos">
          <section className="quem-somos-area page--green container-top">
            
            <div className="container">
              <div className="row flex">
                <div className="col-12 ">
                  <div className="card__content__header">
                    
                    <h1 className="title"><img src={this.images.quem_somos.icon_titulo_top} /> Quem somos</h1>
                  </div>
                  <Fade bottom>
                    <div className="card card--page-body card--green">
                      <div className="card__content">
                        <div className="card__content__body">
                          <p className="gri_text texto-topo">
                            Olá, somos a ANBIMA, a Associação Brasileira das Entidades dos Mercados Financeiro e de Capitais, uma organização sem fins lucrativos. Reunimos bancos, gestoras, corretoras, distribuidoras e administradoras – instituições de diferentes portes e segmentos que retratam a pluralidade do mercado.
                            <br/>
                            <span className="gri_label gri-texto-left">
                              GRI <b>102-1, 102-5, 102-6</b>
                            </span>
                          </p>
                          <p className="gri_text space-text text-quem-somos-line-height">
                          Nascemos em 2009, mas nossa trajetória supera esses 11 anos, pois começou a partir da união de outras duas entidades que, juntas, somam quase um século de história. <br/><br/>
                          Estamos presentes em duas cidades: temos um escritório com as áreas de negócios na capital paulista e uma sede no Rio de Janeiro (RJ). É de lá do Rio que viabilizamos, há 41 anos, as atividades do Selic, o Sistema Especial de Liquidação e de Custódia, do Banco Central. A partir de um convênio com o BC, cuidamos do dia a dia do sistema responsável pela custódia, pelo registro e pela liquidação dos títulos públicos do Tesouro Nacional.
                            <br/>
                            <span className="gri_label gri-texto-left">
                              GRI <b>102-3, 102-4</b>
                            </span>
                            {/* <br />
                            <br /> */}
                            <p className="gri_text space-text text-quem-somos-line-height text-quem-somos-padding">
                              Nossa atuação em defesa dos interesses dos associados está organizada a partir de quatro compromissos: representar, autorregular, informar e educar. Saiba mais sobre cada um abaixo. 
                              <br/>
                              <span className="gri_label gri-texto-left">
                                GRI <b>102-2</b>
                              </span>
                            </p>
                            {/* <br/> */}
                          </p>
                        </div>
                      </div>
                      <div className="card__image">
                        <img src={images.quem_somos.img_quem_somos} />
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <div className="compromissos-area-container">
            {/* <section className="compromissos-area">
              <div className="container">
                <div className="row">
                  <div className="col-5"></div>
                  <div className="col-7">
                    <Fade bottom>
                      <h2 className="green">Compromissos</h2>
                    </Fade>
                  </div>
                </div>
              </div>
            </section> */}

            <section className="compromissos-area compromissos-area--topics">
              <div className="container flex-column">

             
              <div className="col-12 relative" >
                <Fade bottom>
                  <h2 className="green no-margin padding-left-quem-somos">Compromissos</h2>
                </Fade>
                <div className="pessoa_destaque">
                      {/* <img className="pessoa_destaque--cabeca" src={this.images.quem_somos.pessoa3_cabeca} />
                      <img className="pessoa_destaque--braco" src={this.images.quem_somos.pessoa3_braco} /> */}
                      <img className="pessoa_destaque--cabeca" src={this.images.quem_somos.pessoa_destaque} />
                    </div>
              </div>
              <div className="container mobile-margin-zero">
                <div className="row">
                  <div className="col-7 ma">
                    <div className="compromissos_c">
                      <div className="compromissos_c__header">
                        <ul>
                          {this.quem_somos_texts.compromissos.map((item, index) => (
                            <li
                              key={index}
                              className={cActiveQuemSomos == index ? ['active'] : ['']}
                              onClick={() => this.changeTemasButton(index, 'QuemSomos')}
                            >
                              {item.title}
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* <div className="compromissos_c__loader">
                        <div className="loader">
                          <div className="loader_bar" style={{ width: loaderBarWidthQuemSomos }}></div>
                        </div>
                      </div> */}

                      <div className="compromissos_c__content .space-text">
                        <p>{this.quem_somos_texts.compromissos[cActiveQuemSomos].text}</p>
                      </div>

                      <div className="compromissos_c__nav">
                        <div
                          className="c__nav__button c__nav__button--prev"
                          onClick={() => this.changeTemasPrev(cActiveQuemSomos - 1, 'QuemSomos')}
                        ></div>
                        <div className="c__nav__status">
                          <span className="grenn">0{cActiveQuemSomos + 1}</span>-0{maxSlidesQuemSomos + 1}
                        </div>
                        <div
                          className="c__nav__button c__nav__button--next"
                          onClick={() => this.changeTemasNext(cActiveQuemSomos + 1, 'QuemSomos')}
                        ></div>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
              </div>
            </section>
          </div>

          <section className="missao-area">
            <div className="container">
              <div className="row">

                <div className="col-12 flex">
                  <div className="card-visao-missa-valores col-6">
                    <Fade bottom>
                      <h2 className="titulo">
                        Visão,<br/> missão <br/> e valores <br/>
                      </h2>
                      <span className="gri_padding">
                        GRI <b>102-16</b>
                      </span>
                    </Fade>
                    <div className="card-visao-missa-valores-animacao animacao-mt">
                      <img src={images.quem_somos.img_valorese} className="" />
                      <img src={images.quem_somos.icon_visao} className="icon1" />
                      <img src={images.quem_somos.icon_missao} className="icon2" />
                      <img src={images.quem_somos.icon_valores} className="icon3" />
                    </div>
                  </div>
                  <div className="card-visao-missa-valores-descricao col-8">
                    <div className=" card__content--full">
                        <div className="card__content__header--no-border card-flex">
                          <img src={images.quem_somos.icon_visao} className="card__icon" />
                          <h3 className="title title--small no-margin">Visão</h3>
                        </div>
                        <div className="descricao">
                          <p className="p-line-height">Mercado forte se faz com instituições fortes.</p>
                        </div>
                      </div>
                      <div className=" card__content--full">
                        <div className="card__content__header--no-border card-flex">
                          <img src={images.quem_somos.icon_missao} className="card__icon" />
                          <h3 className="title title--small no-margin">Missão</h3>
                        </div>
                        <div className="descricao">
                          <p className="p-line-height">
                            Fortalecer a representação do setor e apoiar a evolução de um mercado de capitais capaz de
                            financiar o desenvolvimento econômico e social local e influenciar o mercado global.
                          </p>
                        </div>
                      </div>
                      <div className=" card__content--full">
                        <div className="card__content__header--no-border card-flex">
                          <img src={images.quem_somos.icon_valores} className="card__icon" />
                          <h3 className="title title--small no-margin">Valores</h3>
                        </div>
                        <div className="descricao">
                          <p className="p-line-height">
                          Cooperação, excelência, inovação, integridade, pluralidade e responsabilidade.
                          </p>
                        </div>
                      </div>
                  </div>
                </div>

              </div>
            </div>
          </section>

         

          <section className="empresas-participamos-area page--yellow">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow no-border">
                      <div className="card__content card__content--full spacing">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title">Empresas de que participamos</h2>
                          <p className="gri_text sub-titulo text-quem-somos-line-height">
                            Nossa atuação se fortalece com a participação em empresas que têm objetivos ligados aos da
                            Associação:{' '}<br/>
                            <span className="gri_label position-grid gri-texto-left gri-left-2020">
                              GRI <b>102-2, 102-13</b>
                            </span>
                          </p>
                        </div>
                        <div className="card__content__body">
                          <div className="row">
                            <div className="col-6">
                              <img src={images.quem_somos.galgo} />
                              <p className="text-quem-somos-galgo-rtm">
                              Criada em 2016, a empresa, da qual somos acionistas com outras 12 entidades, é responsável pelo Sistema Galgo.
                               A plataforma faz a padronização das transferências de informações entre 107 instituições da indústria de fundos
                               somando 610 usuários e 18.442 fundos de investimento cadastrados até o fim de 2020.
                              </p>
                            </div>
                            <div className="col-6">
                              <img src={images.quem_somos.rtm} />
                              <p className="text-quem-somos-galgo-rtm">
                              Maior provedora de serviços para integração do mercado financeiro, a empresa oferece infraestrutura de 
                              telecomunicações e soluções de tecnologia em ambiente de nuvem privada. Estão conectados os principais players
                               e provedores de informações e mais de 550 instituições distribuídas em 19 estados.
                               Somos acionistas de 80% da RTM, enquanto a B3 é dona dos outros 20%.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="perfil-associados-area perfil-associados-area--footer page--green">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="box-pill box-pill--blue box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-3">
                            {/* <img src={images.quem_somos.pessoa1} className="pessoa_destaque pessoa_destaque--1" /> */}
                          </div>
                          <div className="col col-12 col--text">
                            <h4>Saiba mais sobre o perfil dos nossos associados</h4>
                            <DelayLink
                              to="/associados"
                              className="button button--aylen button--white-to-blue button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Saiba mais
                            </DelayLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export { QuemSomos };
